import React from "react";
import { Button, Typography } from "@mui/material";

const SecondaryButton = ({
  height = 50,
  width = "80%",
  style = {},
  sx = {},
  onClick,
  text = "Radiant Button",
  ...props
}) => {
  return (
    <Button
      onClick={onClick}
      variant="outlined"
      color="primary"
      disableElevation
      sx={{
        width,
        height,
        borderRadius: "5px",
        border: "2px solid",
        borderColor: "primary.main",
        backgroundColor: "#FFFFFF",
        color: "primary.main",
        fontWeight: "bold",
        fontSize: 16,
        textTransform: "none",
        boxShadow: "none",
        "&:hover": {
          backgroundColor: "primary.main",
          borderColor: "primary.main",
          color: "#FFFFFF",
          "& .MuiTypography-root": {
            color: "#FFFFFF",
          },
        },
        "& .MuiTypography-root": {
          color: "inherit",
          fontWeight: "bold",
        },
        ...sx,
        ...style,
        borderRadius: "5px",
      }}
      {...props}
    >
      <Typography component="span" sx={{ fontWeight: "bold", color: "inherit" }}>
        {text}
      </Typography>
    </Button>
  );
};

export default SecondaryButton;
